import BrandSpinner from "./BrandSpinner";
import "./LoadingPage.css";
import { useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import { siteTexts } from "../i18n/siteTexts";

type LoadingPageProps = {
  label?: string;
};

export default function LoadingPage({ label = siteTexts.common.loading }: LoadingPageProps) {
  const mountNode = useMemo(() => {
    if (typeof document === "undefined") return null;
    return document.body;
  }, []);

  useEffect(() => {
    if (typeof document === "undefined") return;
    const prevBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevBodyOverflow;
    };
  }, []);

  if (!mountNode) return null;

  return createPortal(
    <div className="loading-page" role="status" aria-live="polite">
      <div className="loading-page__content">
        <BrandSpinner label={label} size="lg" />
      </div>
    </div>,
    mountNode
  );
}
